import React from "react";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";

import { useParams, useSearchParams } from "react-router-dom";
import { useGetVehicleDetailQuery } from "store/services/vehicleApi";

import VehicleInsuranceTabs from "./VehicleInsuranceTabs";
import VehicleNotesTab from "./VehicleNotesTab";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";

import { useListVehicleFuelByVehicleIdQuery } from "store/services/vehicleFuelApi";
import { useListVehicleMaintenanceByVehicleIdQuery } from "store/services/vehicleMaintenanceApi";
import VehicleRegistrationTab from "./VehicleRegistrationTab";
import VehicleMaintenanceTab from "./VehicleMaintenanceTab";
import VehicleFuelTab from "./VehicleFuelTab";
import { useListVehicleLocationByVehicleIdQuery } from "store/services/realTimeTrackingApi";
import VehicleLocationTab from "./VehicleLocationTab";
import DocumentsTab from "../../Document/DocumentTab";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";

const VehicleDetailTab = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "notes";

  const { data: vehicleDetail, isLoading: loadingVehicle } =
    useGetVehicleDetailQuery(id);

  const { data: maintenanceRecords } =
    useListVehicleMaintenanceByVehicleIdQuery(
      { vehicleId: id, active: true },
      { skip: !id }
    );

  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "Shipment", sourceRef: vehicleDetail?._id },
    { skip: !vehicleDetail?._id }
  );

  const { data: fuelRecords } = useListVehicleFuelByVehicleIdQuery(
    { vehicleId: id, active: true },
    { skip: !id }
  );

  const { data: location } = useListVehicleLocationByVehicleIdQuery(
    { vehicleId: id, active: true },
    { skip: !id }
  );

  const vehicleDetailTabs = [
    {
      label: "Notes",
      value: "notes",
      badgeCount: vehicleDetail?.notes?.length,
    },
    {
      label: "Insurance",
      value: "insurance",
      badgeCount: vehicleDetail?.vehicleInsurance?.length,
    },
    {
      label: "Maintenance",
      value: "maintenance",
      badgeCount: maintenanceRecords?.totalItems,
    },
    {
      label: "Document",
      value: "document",
      badgeCount: documents?.totalItems,
    },
    {
      label: "Fuel Record",
      value: "fuel",
      badgeCount: fuelRecords?.totalItems,
    },
    {
      label: "Registration",
      value: "registration",
      badgeCount: vehicleDetail?.vehicleRegistration?.length,
    },
    {
      label: "Last Known Location",
      value: "location",
      badgeCount: location?.totalItems || 0,
    },
  ];

  return (
    <>
      <CustomTabs tabs={vehicleDetailTabs} activeTab={activeTab} />

      {!loadingVehicle ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="maintenance">
            <VehicleMaintenanceTab />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="insurance">
            <VehicleInsuranceTabs />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="notes">
            <VehicleNotesTab />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab
              source="Shipment"
              sourceRef={vehicleDetail._id}
              isActive={vehicleDetail?.isActive}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="fuel">
            <VehicleFuelTab />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="registration">
            <VehicleRegistrationTab />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="location">
            <VehicleLocationTab />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default VehicleDetailTab;
